module.exports = __webpack_public_path__ + "img/epr-article-top-img@2x.9a00306a.webp";